export const environment: {
    production: boolean;
    envName: string;
    backApiUrl: string;
    solutionsApiKey?: string;
    remoteAccess: string;
} = {
    production: false,
    envName: 'dev',
    backApiUrl: 'https://api-preprod.maboussoleaidants.fr/v1/mba-partenaires',
    solutionsApiKey: '6da78ab9-cf3c-43e3-ab83-379198fcc1a2',
    remoteAccess: 'mf.manifest-dev.json',
};
